import { useEffect, useState } from 'react'

import { SaleHistoryDataTable } from '@/components/sales/SaleHistoryDataTable'
import { useBranch } from '@/contexts/BranchContext'
import { fetchStylists } from '@/lib/api/stylists'

/**
 * @param {object} props
 * @param {number | null} [props.initialStylistId]
 */
export function StaffPosHistoryPanel({ initialStylistId = null }) {
  const { activeBranchId } = useBranch()
  const [stylists, setStylists] = useState([])
  const [stylistId, setStylistId] = useState(initialStylistId ?? '')

  useEffect(() => {
    let active = true

    fetchStylists()
      .then((items) => {
        if (!active) return
        const activeStaff = items.filter((item) => item.is_active)
        setStylists(activeStaff)
        if (initialStylistId !== null) {
          setStylistId(String(initialStylistId))
        } else if (activeStaff.length > 0) {
          setStylistId(String(activeStaff[0].id))
        } else {
          setStylistId('')
        }
      })
      .catch(() => {
        if (active) setStylists([])
      })

    return () => {
      active = false
    }
  }, [activeBranchId, initialStylistId])

  const resolvedStylistId = stylistId === '' ? null : Number(stylistId)
  const stylistName = stylists.find((item) => item.id === resolvedStylistId)?.name

  return (
    <div className="space-y-4">
      <div className="salon-panel p-4">
        <label className="block max-w-sm space-y-1.5">
          <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
            Staff member
          </span>
          <select
            value={stylistId}
            onChange={(e) => setStylistId(e.target.value)}
            className="h-11 w-full rounded-xl border border-border/80 bg-background px-3 text-sm"
          >
            <option value="" disabled>
              Select staff…
            </option>
            {stylists.map((stylist) => (
              <option key={stylist.id} value={stylist.id}>
                {stylist.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <SaleHistoryDataTable
        rowMode="line"
        showCustomerFilter={false}
        showSearch
        stylistId={resolvedStylistId}
        requireStylist
        tableTitle={stylistName ? `${stylistName} — tickets` : 'Staff tickets'}
        emptyLabel="No tickets for this staff member in the selected period."
      />
    </div>
  )
}
